import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { faCopy, faEye } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { HealthService } from 'src/app/pages/privado/services/saude/health.service';
import { ReembolsoService } from 'src/app/pages/privado/services/saude/reembolso.service';
import { ModalHistoricoReembolsoComponent } from 'src/app/shared/modals/modal-historico-reembolso/modal-historico-reembolso.component';
import { TokenService } from 'src/app/shared/services/token.service';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
@Component({
  selector: 'app-meus-reembolsos',
  templateUrl: './meus-reembolsos.component.html',
  styleUrls: ['./meus-reembolsos.component.css']
})
export class MeusReembolsosComponent implements OnInit {
  faCopy = faCopy;
  faEye = faEye;
  cpf;
  titular: any;
  loading: boolean = false;
  refundTypes!: any[];
  refundStatus!: any[];
  beneficiaries!: any[];
  myRefundRequests: any;
  myRequestsFilter: any = { itemsPerPage: 5, page: 0 };
  formData: FormGroup = new FormGroup({
    itemsPerPage: new FormControl(5),
    page: new FormControl(0),
    beneficiaryId: new FormControl(null),
    refundTypeId: new FormControl(null),
    refundStatusId: new FormControl(null),
    protocol: new FormControl(null)
  });
  constructor(private toast: ToastrService, private tokenService: TokenService, private healthService: HealthService, private refundService: ReembolsoService, public userService: UsuarioService, private modalService: NgbModal) {
    let user = this.tokenService.getActiveUser();
    if (user) this.cpf = user.cpf;
    this.healthService.getBeneficiaryAndHealthData().subscribe((res: any) => {
      this.titular = res.filter((a: any) => a.titular)[0];
      this.titular.name = this.titular.name.split(' ')[0] + ' ' + this.titular.name.split(' ')[1];
    });
    this.userService.getBeneficiaries().subscribe((res: any) => {
      this.beneficiaries = res;
    });
    this.refundService.getRefundTypes().subscribe((res: any) => {
      this.refundTypes = res;
    });
    this.refundService.getRefundStatus().subscribe((res: any) => {
      this.refundStatus = res;
    });
  }
  ngOnInit(): void {
    this.getFilter();
  }
  getFilter() {
    this.loading = true;
    this.refundService.getRefunds({
      itemsPerPage: this.formData.value.itemsPerPage,
      page: (this.formData.value.page - 1),
      beneficiaryId: this.formData.value.beneficiaryId,
      refundTypeId: this.formData.value.refundTypeId,
      refundStatusId: this.formData.value.refundStatusId,
      protocol: this.formData.value.protocol,
    }).subscribe((res: any) => {
      this.myRefundRequests = res;
      this.loading = false;
    });
  }
  copiarTexto(value: any) {
    navigator.clipboard.writeText(value);
    this.toast.success("Protocolo copiado!")
  }
  detalhesReembolso(value: any) {
    const modalRef = this.modalService.open(ModalHistoricoReembolsoComponent, { windowClass: 'carteirinha-modal-size', centered: true });
    modalRef.componentInstance.details = value;
  }
  getRefundStatusColor(status: number) {
    let color = '#707070';
    if (status == 1) {
      color = '#E4E408'
    } else if (status == 2) {
      color = '#3CCB1B';
    } else if (status == 3) {
      color = '#3D8EEB'
    } else if (status == 4) {
      color = '#EF3F3F'
    }
    return color;
  }
  onChangeQuantidadeItens(quantidade: number) {
    this.myRequestsFilter.itemsPerPage = quantidade;
    this.myRequestsFilter.page = 1;
    this.formData.get('itemsPerPage')?.setValue(quantidade);
    this.refundService.getRefunds(
      {
        itemsPerPage: this.formData.value.itemsPerPage,
        page: (this.formData.value.page - 1),
        beneficiaryId: this.formData.value.beneficiaryId,
        refundTypeId: this.formData.value.refundTypeId,
        refundStatusId: this.formData.value.refundStatusId,
        protocol: this.formData.value.protocol,
      }
    ).subscribe((res: any) => {
      this.myRefundRequests = res;
      this.loading = false;
    });
  }
  onChangePagination(page: number) {
    if (page != this.myRequestsFilter.page) {
      this.myRequestsFilter.page = page;
      this.formData.get('page')?.setValue(page);
      this.refundService.getRefunds(
        {
          itemsPerPage: this.formData.value.itemsPerPage,
          page: (this.formData.value.page - 1),
          beneficiaryId: this.formData.value.beneficiaryId,
          refundTypeId: this.formData.value.refundTypeId,
          refundStatusId: this.formData.value.refundStatusId,
          protocol: this.formData.value.protocol,
        }
      ).subscribe((res: any) => {
        this.myRefundRequests = res;
        this.loading = false;
      });
    }
  }
}
